import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { capitalizeText } from '@cat-ecom/common/utils/stringUtils';

interface StoreHoursInfoType {
  index: number;
  label: string;
  value: string;
  currentDay: boolean;
}

const validate24Hours = (rangeHour: string) => {
  const openAndCloseHour = rangeHour.split(" - ")

  // Hour range example: 08:00 AM - 05:00 PM
  const isOpenHourAlwaysOpen = openAndCloseHour[0] === "00:00" || openAndCloseHour[0] === "12:00 AM"
  const isCloseHourAlwaysOpen = openAndCloseHour[1] === "00:00" || openAndCloseHour[1] === "12:00 AM"

  return openAndCloseHour.length === 2 && (isOpenHourAlwaysOpen) && (isCloseHourAlwaysOpen)
}

/**
 * Validate if the store hour applies to a always open store. This is a temporal validation. This one should come from the backend.
 * @param storeHours Hour ranges of the store
 * @returns if store is always open.
 */
export const isStoreAlwaysOpen = (storeHours: Partial<StoreHoursInfoType>[]) =>
  !isEmpty(storeHours) && storeHours.every(storeHour => validate24Hours(storeHour.value))


export const getStoreHours = (storeHours, open24Label: string): StoreHoursInfoType[] => {
  return storeHours.reduce(
    (acc: StoreHoursInfoType, current: StoreHoursInfoType, i: number): StoreHoursInfoType => {
      acc[current.index] = {
        ...current,
        label: capitalizeText(current.label),
        currentDay: i === 0,
        value: validate24Hours(current.value) ? open24Label : current.value
      };
      return acc;
    },
    []
  );
}

export const isStoreClosed = (storeHours: Partial<StoreHoursInfoType>[], closedLabel: string) => !isEmpty(storeHours) && storeHours.every(({ value }) => value === closedLabel);